export default __webpack_public_path__ + "027dc3412cb642349ec0efe5ea4bcf9d.png";